export default "__VITE_ASSET__BtiKOZE6__"